import { BaseClient, IActionResponse, IActionResult, IPagedResult } from "../";
import { ApiParams } from "../../../assets/utils/lib";
import {
  ServiceRequestDto,
  ServiceRequestActionDto,
  ServiceRequestLookupsDto,
  ServiceRequestCommentDto,
  ServiceRequestSearchDto,
  ServiceRequestGridDto,
  ServiceRequestDashboardCountDto,
  ServiceRequestCommentsViewDto,
  ServiceRequestActionViewDto,
} from "../../dto";

export class ServiceRequestClient extends BaseClient {
  routes = ["admin", "ServiceRequest"];

  async getServiceRequestAsync(
    id: string | undefined,
  ): Promise<ServiceRequestDto> {
    const actions: string[] = ["GetServiceRequest"];
    const params: ApiParams[] = [new ApiParams("Id", id, true)];
    const result: ServiceRequestDto = await this.getAsync<ServiceRequestDto>(
      actions,
      params,
    );
    return result;
  }

  async searchServiceRequestsAsync(
    payload: ServiceRequestSearchDto | undefined,
  ): Promise<IPagedResult<ServiceRequestGridDto>> {
    const actions: string[] = ["SearchServiceRequest"];
    const result: IPagedResult<ServiceRequestGridDto> = await this.postAsync<
      ServiceRequestSearchDto,
      ServiceRequestGridDto,
      IPagedResult<ServiceRequestGridDto>
    >(actions, payload);
    return result;
  }

  async saveServiceRequestAsync(
    payload: ServiceRequestDto,
  ): Promise<IActionResult<ServiceRequestDto>> {
    const actions: string[] = ["SaveServiceRequest"];
    return await this.postAsync<
      ServiceRequestDto,
      ServiceRequestDto,
      IActionResult<ServiceRequestDto>
    >(actions, payload);
  }

  async addNoteAsync(
      payload: ServiceRequestCommentDto | undefined,
  ): Promise<IActionResult<ServiceRequestCommentDto>> {
    const actions: string[] = ["SaveServiceRequestNotes"];
    return await this.postAsync<ServiceRequestCommentDto>(actions, payload);
  }

    async getServiceRequestNotesAsync(
        id: string | undefined,
    ): Promise<ServiceRequestCommentsViewDto[]> {
        const actions: string[] = ["GetServiceRequestNotes"];
        const params: ApiParams[] = [new ApiParams("Id", id, true)];
        const result: ServiceRequestCommentsViewDto[] = await this.getAsync<ServiceRequestCommentsViewDto[]>(
            actions,
            params,
        );
        return result;
    }

    async getServiceRequestActionsAsync(
        id: string | undefined,
    ): Promise<ServiceRequestActionViewDto[]> {
        const actions: string[] = ["GetServiceRequestActions"];
        const params: ApiParams[] = [new ApiParams("Id", id, true)];
        const result: ServiceRequestActionViewDto[] = await this.getAsync<ServiceRequestActionViewDto[]>(
            actions,
            params,
        );
        return result;
    }

  async completeRequestAsync(id: string | undefined): Promise<IActionResponse> {
    const actions: string[] = ["CompleteServiceRequest"];
    const params: ApiParams[] = [new ApiParams("Id", id, true)];
    return await this.getAsync(actions, params);
  }

  async closeRequestAsync(id: string | undefined): Promise<IActionResponse> {
    const actions: string[] = ["CloseServiceRequest"];
    const params: ApiParams[] = [new ApiParams("Id", id, true)];
    return await this.getAsync(actions, params);
  }

  async getLookupsAsync(): Promise<ServiceRequestLookupsDto> {
    const actions: string[] = ["GetLookups"];
    return await this.getAsync<ServiceRequestLookupsDto>(actions);
  }

  async getDashboardCountsAsync(): Promise<ServiceRequestDashboardCountDto> {
    const actions: string[] = ["GetServiceRequestDashboardCounts"];
    return await this.getAsync<ServiceRequestDashboardCountDto>(actions);
  }
}
